'use client';

import 'react-diff-view/style/index.css';

import { ArrowUturnLeftIcon, CheckIcon } from '@heroicons/react/16/solid';
import { Diff, Hunk, parseDiff } from 'react-diff-view';
import { diffLines, formatLines } from 'unidiff';

import { DropdownConfirm } from '@/shared';
import { useScreen } from '@/shared/hooks';

export const DiffContent = ({
	title,
	left,
	right,
	onConfirm,
	onReset,
}: {
	title: string;
	left: string;
	right: string;
	onConfirm?: () => void;
	onReset?: () => void;
}) => {
	const screen = useScreen();
	const viewType = screen.lg ? 'split' : 'unified';

	const diffText = formatLines(diffLines(left, right), { context: 3 });
	const [diff] = parseDiff(diffText, { nearbySequences: 'zip' });

	if (!diff.hunks.length) {
		return null;
	}

	return (
		diff.hunks.length > 0 && (
			<>
				<div className="sticky top-0 my-3 flex items-center gap-3 bg-white px-5 py-2 text-xl font-bold">
					{title}
					<div className="flex-1" />
					{onReset && (
						<DropdownConfirm
							variant="plain-gray"
							size="sm"
							text="Отменить изменения?"
							confirmVariant="red"
							confirmText="Отменить"
							cancelText="Оставить"
							onConfirm={onReset}
						>
							<ArrowUturnLeftIcon className="size-5" />
						</DropdownConfirm>
					)}
					{onConfirm && (
						<DropdownConfirm
							variant="plain-gray"
							size="sm"
							text="Сохранить?"
							confirmVariant="green"
							onConfirm={onConfirm}
						>
							<CheckIcon className="size-5" />
						</DropdownConfirm>
					)}
				</div>
				<Diff viewType={viewType} diffType="modify" hunks={diff.hunks}>
					{(hunks) =>
						hunks.map((hunk) => <Hunk key={hunk.content} hunk={hunk} />)
					}
				</Diff>
			</>
		)
	);
};
